import React from 'react';
import meterProduct from '../../assets/meter/meter-product.png';

// Same bespoke network-node visual language as the homepage hero, reused
// here so the two pages read as one design system, not two different sites.
const NetworkGlow = () => (
  <svg className="mh-hero__network" viewBox="0 0 520 460" fill="none" aria-hidden="true">
    {[
      [[90, 320], [230, 260]], [[230, 260], [340, 300]],
      [[230, 260], [260, 140]], [[340, 300], [400, 180]],
      [[260, 140], [400, 180]], [[400, 180], [470, 90]],
    ].map(([p1, p2], i) => (
      <React.Fragment key={i}>
        <line x1={p1[0]} y1={p1[1]} x2={p2[0]} y2={p2[1]} className="mh-hero__link-base" />
        <line x1={p1[0]} y1={p1[1]} x2={p2[0]} y2={p2[1]} className="mh-hero__link" style={{ animationDelay: `${i * 0.4}s` }} />
      </React.Fragment>
    ))}
    {[[90, 320], [230, 260], [340, 300], [260, 140], [400, 180]].map((n, i) => (
      <rect key={i} x={n[0] - 5} y={n[1] - 5} width="10" height="10" className="mh-hero__node" style={{ animationDelay: `${i * 0.35}s` }} />
    ))}
    <circle cx="470" cy="90" r="16" className="mh-hero__gateway-ring" />
    <rect x="464" y="84" width="12" height="12" className="mh-hero__gateway-core" />
  </svg>
);

const MeterHero = () => (
  <section className="mh-hero" id="meter-hero">
    <div className="mh-hero__backdrop" aria-hidden="true" />
    <img
      src={meterProduct}
      alt="The GRIDx smart meter"
      className="mh-hero__meter-photo"
      width="900"
      height="1277"
    />
    <NetworkGlow />
    <div className="mh-hero__content">
      <span className="eyebrow">GRIDx Meter</span>
      <h1 className="mh-hero__title">GRIDx Smart Metering Platform</h1>
      <p className="mh-hero__subtitle">
        Revolutionizing energy management and connectivity across Africa
      </p>
      <div className="mh-hero__actions">
        <a href="/contact" className="btn btn--primary">Get in Touch</a>
        <a href="#how-it-works" className="btn btn--outline-dark">See How It Works</a>
      </div>
    </div>
  </section>
);

export default MeterHero;
